module.exports = __webpack_public_path__ + "img/bg_product.8caeb866.png";